import React, { useEffect } from "react";
import StudentReportIcon from "assets/imgs/StudentReport/StudentReportIcon.svg";
import NotificationDropdown from "components/NotificationDropdown/NotificationDropdown";
import ProfileDropdown from "components/ProfileDropdown/ProfileDropdown";
import { AuthContext } from "context/AuthContext";
import { forwardRef, useContext } from "react";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import { useQueries, useQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "routes";
import getProfile from "service/user/shared/get-profile";
import "./header.scss";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import HomeHeader from "assets/imgs/icons/home_header.svg";
import ChatHeader from "assets/imgs/icons/chat_header.svg";
import SubjectHeader from "assets/imgs/icons/subject_header.svg";
import SettingsHeader from "assets/imgs/icons/settings_header.svg";
import { TreePicker } from "rsuite";
import getCourseList from "service/courses/course-list";
import ListMySessions from "assets/imgs/CsmPages/listMySessions.svg";
import ChatNotification from "../ChatNotification/ChatNotification";
import getTutors from "service/user/csm/chat/get-tutors";
import getParents from "service/user/csm/chat/get-parents";
import { db } from "../../../firebase";
import { getDoc, doc } from "firebase/firestore";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { ChatContext } from "context/ChatContext";
import { useState } from "react";
import GlobalSearch from "../GlobalSearch/GlobalSearch";

const renderTooltip = (props) => <Tooltip id="header-tooltip">{props}</Tooltip>;
const CoursesToggle = React.forwardRef(({ children, onClick }, ref) => (
  <OverlayTrigger placement="top" overlay={renderTooltip("Courses")}>
    <div ref={ref} onClick={onClick} className="header__filter-btn">
      <img src={SubjectHeader} alt="" className="mx-2 cif__header-icon" />
    </div>
  </OverlayTrigger>
));

function Header() {
  const navigate = useNavigate();
  const { authState, logout } = useContext(AuthContext);
  const userFbId = authState?.userInfo?.firebaseUid;
  const [newMessage, setNewMessage] = useState(false);
  const { isLoading, error, data } = useQuery(
    ["profile", authState?.userInfo?.cifNumber],
    () => getProfile(authState.userInfo.cifNumber),
    {
      enabled: !!authState?.userInfo?.cifNumber,
    }
  );

  const queries = useQueries({
    queries: [
      {
        queryKey: ["parent-list"],
        queryFn: () => getParents(authState?.userInfo?.cifNumber),
        enabled: !!authState?.userInfo?.cifNumber,
        onSuccess: (d) => {
          if (d && d.length > 0) {
            let list = [];

            list = d.filter((item) => {
              if (item.firebaseId) {
                return item.firebaseId;
              }
            });
            _loadUsers(list, "parent");
          }
        },
      },
      {
        queryKey: ["tutors-list"],
        queryFn: () => getTutors(authState?.userInfo?.cifNumber),
        enabled: !!authState?.userInfo?.cifNumber,
        onSuccess: (d) => {
          // console.log(d);
          if (d && d.length > 0) {
            let list = [];

            list = d.filter((item) => {
              if (item.firebaseId) {
                return item.firebaseId;
              }
            });
            _loadUsers(list, "tutor");
          }
        },
      },
    ],
  });

  const courseList = useQuery(["course-list"], getCourseList);

  const courseTreedata = [
    {
      value: "Beginner",
      label: "Beginner",
      children: courseList.data?.Beginner?.map(({ courseName, courseId }) => {
        return {
          value: courseId,
          label: courseName,
        };
      }),
    },
    {
      value: "Intermediate",
      label: "Intermediate",
      children: courseList.data?.Intermediate?.map(
        ({ courseName, courseId }) => {
          return {
            value: courseId,
            label: courseName,
          };
        }
      ),
    },
    {
      value: "Advanced",
      label: "Advanced",
      children: courseList.data?.Advanced?.map(({ courseName, courseId }) => {
        return {
          value: courseId,
          label: courseName,
        };
      }),
    },
  ];

  const _loadUsers = async (list, type) => {
    list = list.map((l) => l.firebaseId);
    let users = [];
    if (list.length > 10) {
      let newList = [];
      for (let i = 0; i < list.length / 10; i++) {
        newList.push(
          list.filter((l, ind) => {
            if (ind >= i * 10 && ind < (i + 1) * 10) {
              return l;
            }
          })
        );
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("uid", "in", newList[i]));
        const unsub = onSnapshot(q, (querySnapshot) => {
          querySnapshot.forEach((doc) => {
            users.push(doc.data());
          });
          let newUsers = [];
          users.map((user) => {
            let userId = user.uid;
            const id =
              userFbId > userId
                ? `${userFbId + userId}`
                : `${userId + userFbId}`;
            onSnapshot(doc(db, "lastMsg", id), (doc) => {
              let data = doc.data();
              newUsers = newUsers.filter(function (obj) {
                return obj?.uid !== data?.from && obj?.uid !== data?.to;
              });
              newUsers.push(data);
              if (data?.unread && data?.to === userFbId && !newMessage) {
                setNewMessage(true);
              }
            });
            // return () => unsub2();
          });
        });
        // return () => unsub();
      }
    } else {
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("uid", "in", list));
      const unsub = onSnapshot(q, (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push(doc.data());
        });
        let newUsers = [];
        users.map((user) => {
          let userId = user.uid;
          const id =
            userFbId > userId ? `${userFbId + userId}` : `${userId + userFbId}`;
          onSnapshot(doc(db, "lastMsg", id), (doc) => {
            let data = doc.data();
            newUsers = newUsers.filter(function (obj) {
              return obj?.uid !== data?.from && obj?.uid !== data?.to;
            });
            newUsers.push(data);
            if (data?.unread && data?.to === userFbId && !newMessage) {
              setNewMessage(true);
            }
          });
        });
      });
      return () => unsub();
    }
  };

  return (
    <>
      <ChatNotification />
      <Navbar className="cif__header" expand={true}>
        <Container fluid className={"cif__nav-container"}>
          <div className="d-flex gap-3">
            <Navbar.Brand href={ROUTES.CSM_DASHBOARD}>
              <OverlayTrigger placement="top" overlay={renderTooltip("Home")}>
                <img
                  src={HomeHeader}
                  alt=""
                  className="cifHeaderIcon cif__header-icon"
                />
              </OverlayTrigger>
            </Navbar.Brand>
            <div className="cif__nav-item cif__nav-form-container d-none d-lg-flex gap-1 cifHeader__filter_wrapper">
              <GlobalSearch />
            </div>
          </div>

          <div className="d-flex gap-3">
            <div className="cif__nav-item d-flex gap-3 header__nav-link-group align-items-center">
              <>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("List My Sessions")}
                >
                  <Link
                    to={ROUTES.CSM_LIST_MY_STUDENTS}
                    className="csmHeader__nav_item "
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="">
                      <img
                        src={ListMySessions}
                        className="cif__header-icon mx-2"
                      />
                    </div>
                  </Link>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Student Report")}
                >
                  <Link
                    to={ROUTES.CSM_STUDENT_REPORT}
                    className="csmHeader__nav_item "
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="">
                      <img
                        src={StudentReportIcon}
                        className="cif__header-icon mx-2"
                      />
                    </div>
                  </Link>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={renderTooltip("Chat")}>
                  {/* <Link
                to={ROUTES.VIEW_SCHEDULE}
                className=" ms-2 text-decoration-none"
              > */}
                  <div className={`${newMessage ? "new-message" : ""}`}>
                    <img
                      className={`cursor-pointer cif__header-icon mx-2 `}
                      onClick={() => navigate(ROUTES.CMS_CHAT)}
                      src={ChatHeader}
                      alt=""
                    />
                  </div>
                  {/* </Link> */}
                </OverlayTrigger>
                <TreePicker
                  menuClassName="header__course_menu_box"
                  block={false}
                  data={courseTreedata}
                  toggleAs={CoursesToggle}
                  placeholder="Filter"
                  caretAs={null}
                  onSelect={({ value, label }) => {
                    // console.log("Value : ", value);
                    // console.log("Label : ", label);
                    navigate(ROUTES.CSM_ADD_SUBJECT, {
                      state: { courseId: value, course: label },
                    });
                  }}
                />
              </>
              <NotificationDropdown />
              <OverlayTrigger
                placement="top"
                overlay={renderTooltip("Settings")}
              >
                <Link to={ROUTES.CSM_SETTINGS} className="cursor-pointer ">
                  <img
                    className="cursor-pointer cif__header-icon mx-2"
                    src={SettingsHeader}
                    alt=""
                  />
                </Link>
              </OverlayTrigger>
            </div>
            <div className="d-flex align-items-center profile-dropdown-container">
              <ProfileDropdown title={data?.fullName} />
            </div>
          </div>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
